var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30H21.5C22.8807 30 24 28.8807 24 27.5V9.62018C24 8.94933 23.7304 8.30663 23.2518 7.83656L16.0021 0.71638C15.5347 0.257247 14.9056 0 14.2504 0H2.5C1.11929 0 0 1.11929 0 2.5V27.5C0 28.8807 1.11929 30 2.5 30Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5 14.7239 5.22386 14.5 5.5 14.5H8C8.27614 14.5 8.5 14.7239 8.5 15V16.3333C8.5 16.6095 8.27614 16.8333 8 16.8333H5.5C5.22386 16.8333 5 16.6095 5 16.3333V15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.0833C5 18.8072 5.22386 18.5833 5.5 18.5833H8C8.27614 18.5833 8.5 18.8072 8.5 19.0833V20.4167C8.5 20.6928 8.27614 20.9167 8 20.9167H5.5C5.22386 20.9167 5 20.6928 5 20.4167V19.0833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23.1667C5 22.8905 5.22386 22.6667 5.5 22.6667H8C8.27614 22.6667 8.5 22.8905 8.5 23.1667V24.5C8.5 24.7761 8.27614 25 8 25H5.5C5.22386 25 5 24.7761 5 24.5V23.1667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15C10.25 14.7239 10.4739 14.5 10.75 14.5H13.25C13.5261 14.5 13.75 14.7239 13.75 15V16.3333C13.75 16.6095 13.5261 16.8333 13.25 16.8333H10.75C10.4739 16.8333 10.25 16.6095 10.25 16.3333V15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 19.0833C10.25 18.8072 10.4739 18.5833 10.75 18.5833H13.25C13.5261 18.5833 13.75 18.8072 13.75 19.0833V20.4167C13.75 20.6928 13.5261 20.9167 13.25 20.9167H10.75C10.4739 20.9167 10.25 20.6928 10.25 20.4167V19.0833Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 23.1667C10.25 22.8905 10.4739 22.6667 10.75 22.6667H13.25C13.5261 22.6667 13.75 22.8905 13.75 23.1667V24.5C13.75 24.7761 13.5261 25 13.25 25H10.75C10.4739 25 10.25 24.7761 10.25 24.5V23.1667Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15C15.5 14.7239 15.7239 14.5 16 14.5H18.5C18.7761 14.5 19 14.7239 19 15V16.3333C19 16.6095 18.7761 16.8333 18.5 16.8333H16C15.7239 16.8333 15.5 16.6095 15.5 16.3333V15Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.0833C15.5 18.8072 15.7239 18.5833 16 18.5833H18.5C18.7761 18.5833 19 18.8072 19 19.0833V20.4167C19 20.6928 18.7761 20.9167 18.5 20.9167H16C15.7239 20.9167 15.5 20.6928 15.5 20.4167V19.0833Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.1667C15.5 22.8905 15.7239 22.6667 16 22.6667H18.5C18.7761 22.6667 19 22.8905 19 23.1667V24.5C19 24.7761 18.7761 25 18.5 25H16C15.7239 25 15.5 24.7761 15.5 24.5V23.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeSpreadsheet);
export default __webpack_public_path__ + "static/media/file-type-spreadsheet.c960925fe57de955dcfb90a8ede7eb65.svg";
export { ForwardRef as ReactComponent };